/** @format */

import { END_POINT, headersFormData, objectToQueryString } from "utils";
import { deleteRequest, getRequest, postRequest } from "./axios";
import { IdForm, FormTaskStore, FormTaskUpdate, inputQueryTask, FormAttachmentTask, FormDetachTask } from "types";
import { toFormData } from "axios";

export const taskService = {
  onGetList: async (projectId, page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/tasks?page=${page}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  onSearch: async (projectId, input: inputQueryTask) => {
    console.log("🚀 ~ input:", objectToQueryString(input))
    try {

      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/tasks/search?page=1&${objectToQueryString(input)}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  show: async (projectId, id) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/tasks/${id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  store: async (payload: FormTaskStore) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tasks`, toFormData(payload), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  update: async (payload: FormTaskUpdate) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tasks/${payload.id}`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  attachment: async (payload: FormAttachmentTask) => {
    console.log("🚀 ~ payload:", payload)
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tasks/${payload.id}/attachment`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  detach: async (payload: FormDetachTask) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tasks/${payload.id}/detach`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  destroy: async (payload: IdForm) => {
    try {
      const rs = await deleteRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tasks/${payload.id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};

